import { render, staticRenderFns } from "./ResultCridential.vue?vue&type=template&id=825e1e24&scoped=true&"
import script from "./ResultCridential.vue?vue&type=script&lang=js&"
export * from "./ResultCridential.vue?vue&type=script&lang=js&"
import style0 from "./ResultCridential.vue?vue&type=style&index=0&id=825e1e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825e1e24",
  null
  
)

export default component.exports